import { FONTS } from '@wix/shoutout-email-model-v3';
const HARDCODED_FONTS = Object.values(FONTS);
export const getUnformattedFontDisplayName = displayName => {
  var _HARDCODED_FONTS$find;
  return (_HARDCODED_FONTS$find = HARDCODED_FONTS.find(font => font.displayName.toLowerCase() === displayName.toLowerCase())) == null ? void 0 : _HARDCODED_FONTS$find.displayName;
};
//# sourceMappingURL=getUnformattedFontDisplayName.js.map